/**
 * Centralized socket event names. Prevents typos, eases refactoring, consistent naming.
 */
export const SOCKET_EVENTS = {
  // Connection (Socket.IO built-in)
  CONNECT: "connect",
  DISCONNECT: "disconnect",
  CONNECT_ERROR: "connect_error",

  // App-level events
  FINANCIAL_UPDATE: "financial:update",
  BALANCE_CHANGED: "balance_changed",
  ORDER_UPDATED: "order_updated",
  TRADE_EXECUTED: "trade_executed",
  PRICE_TICK: "price_tick",

  // Emit-only (client → server)
  SUBSCRIBE_PROPERTY: "subscribe_property",
  UNSUBSCRIBE_PROPERTY: "unsubscribe_property",
};
